import { useEffect } from 'react'

interface SEOHeadProps {
  title: string
  description: string
  keywords?: string
  canonicalUrl?: string
  ogType?: string
  ogImage?: string
  schema?: Record<string, unknown>
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website', ogImage, schema }: SEOHeadProps) {
  useEffect(() => {
    document.title = title
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', description)
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords && keywords) {
      metaKeywords.setAttribute('content', keywords)
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]')
    if (canonicalLink && canonicalUrl) {
      canonicalLink.setAttribute('href', canonicalUrl)
    }

    const ogTitle = document.querySelector('meta[property="og:title"]')
    if (ogTitle) ogTitle.setAttribute('content', title)

    const ogDesc = document.querySelector('meta[property="og:description"]')
    if (ogDesc) ogDesc.setAttribute('content', description)

    const ogTypeMeta = document.querySelector('meta[property="og:type"]')
    if (ogTypeMeta) ogTypeMeta.setAttribute('content', ogType)

    const ogUrl = document.querySelector('meta[property="og:url"]')
    if (ogUrl && canonicalUrl) ogUrl.setAttribute('content', canonicalUrl)

    if (ogImage) {
      const existingOgImage = document.querySelector('meta[property="og:image"]')
      if (existingOgImage) {
        existingOgImage.setAttribute('content', ogImage)
      } else {
        const meta = document.createElement('meta')
        meta.setAttribute('property', 'og:image')
        meta.setAttribute('content', ogImage)
        document.head.appendChild(meta)
      }
    }

    const twitterTitle = document.querySelector('meta[name="twitter:title"]')
    if (twitterTitle) twitterTitle.setAttribute('content', title)

    const twitterDesc = document.querySelector('meta[name="twitter:description"]')
    if (twitterDesc) twitterDesc.setAttribute('content', description)

    if (schema) {
      const existingSchema = document.querySelector('script[data-dynamic-schema]')
      if (existingSchema) existingSchema.remove()

      const script = document.createElement('script')
      script.type = 'application/ld+json'
      script.setAttribute('data-dynamic-schema', 'true')
      script.textContent = JSON.stringify(schema)
      document.head.appendChild(script)
    }

    return () => {
      const dynamicSchema = document.querySelector('script[data-dynamic-schema]')
      if (dynamicSchema) dynamicSchema.remove()
    }
  }, [title, description, keywords, canonicalUrl, ogType, ogImage, schema])

  return null
}